"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var FormItemView = function (props) {
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("div", { className: "__item" },
            react_1.default.createElement("span", { className: "__caption" }, props.caption),
            react_1.default.createElement("input", { disabled: true, defaultValue: props.value }))));
};
exports.default = FormItemView;
